 


/* @ngInject */ 
export default function CacheService($cacheFactory) {
	return $cacheFactory('PretorCache');
}
